var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "connection"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "page"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "support"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "configuration"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "cloud_storage"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "password"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "search_engine"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "history"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SEO"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "optimization"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,33c4.4,0,8-3.6,8-8s-3.6-8-8-8s-8,3.6-8,8S45.6,33,50,33z M50,19c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6    S46.7,19,50,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,26h4c0.6,0,1-0.4,1-1s-0.4-1-1-1h-3v-2c0-0.6-0.4-1-1-1s-1,0.4-1,1v3C49,25.6,49.4,26,50,26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,70h-0.8l-1.2-0.4L73.2,56H77c0.3,0,0.6-0.1,0.8-0.4C78,55.4,78,55,78,54.7l-5-18c-0.1-0.4-0.5-0.7-1-0.7h-4.1    c-0.5-2.3-2.5-4-4.9-4h-1V20.7c0-7.4-4.7-14.1-11.7-16.6c-0.2-0.1-0.5-0.1-0.7,0C42.7,6.6,38,13.3,38,20.7V32h-1    c-2.4,0-4.4,1.7-4.9,4H28c-0.4,0-0.8,0.3-1,0.7l-5,18c-0.1,0.3,0,0.6,0.2,0.9c0.2,0.2,0.5,0.4,0.8,0.4h3.8l-2.7,13.6L22.8,70H22    c-2.8,0-5,2.2-5,5v20c0,0.6,0.4,1,1,1h64c0.6,0,1-0.4,1-1V75C83,72.2,80.8,70,78,70z M43,50h14v4H43V50z M50,63.1L70.8,70H29.2    L50,63.1z M73.8,68.9L51,61.3V56h7c0.6,0,1-0.4,1-1v-5h1v1c0,0.6,0.4,1,1,1h5v3c0,0.6,0.4,1,1,1h4.2L73.8,68.9z M75.7,54H68v-3V38    h3.2L75.7,54z M63,34c1.7,0,3,1.3,3,3v13h-4v-1V34H63z M40,20.7c0-6.5,4-12.3,10-14.6c6,2.3,10,8.2,10,14.6V33v15h-2H42h-2V33    V20.7z M37,34h1v15v1h-4V37C34,35.3,35.3,34,37,34z M28.8,38H32v13v3h-7.7L28.8,38z M28.8,56H33c0.6,0,1-0.4,1-1v-3h5    c0.6,0,1-0.4,1-1v-1h1v5c0,0.6,0.4,1,1,1h7v5.3l-22.8,7.6L28.8,56z M22,72h56c1.7,0,3,1.3,3,3v5H19v-5C19,73.3,20.3,72,22,72z     M19,94V82h62v12H19z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 76,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 76,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 76,
    r: 2
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "backlink"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "performance"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "analytics"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "security"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "dark_web"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "video_player"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "upload_download"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "incognito_tab"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "bookmark"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcket);
export default __webpack_public_path__ + "static/media/procket.f9e4b1588f04d492944f7b8e69aab640.svg";
export { ForwardRef as ReactComponent };